import { useQuery } from "@tanstack/react-query";
import { fetchAllPayouts, fetchAllActivities } from "../data/index.jsx";

export function FetchAllPayouts() {
	const { isLoading: fetchingPayouts, data: allPayouts = [] } = useQuery({
		queryKey: ["all-payouts"],
		queryFn: fetchAllPayouts,
		staleTime: Infinity,
	});

	return { fetchingPayouts, allPayouts };
}

export function FetchAllActivities() {
	const { isLoading: fetchingActivities, data: allActivities = [] } = useQuery({
		queryKey: ["all-activities"],
		queryFn: fetchAllActivities,
		staleTime: Infinity,
	});

	return { fetchingActivities, allActivities };
}
